import { call, put, takeLatest, takeEvery, select } from 'redux-saga/effects';
import deviceService from 'src/services/deviceService';
import firebaseService from 'src/services/firebase';
import { ActionTypes } from 'src/store/constants';
import { message } from 'antd';
import { isDevelopment } from 'src/module/helpers';

// Action untuk initialize device
export function* initializeDevice() {
    try {
        const state = yield select();
        const user = state.authentication;
        const profile = state?.Profile?.response?.full
        const appSetting = state?.app_setting?.response
        const isAllowedPush = appSetting?.user_config?.push_notifications === 1


        if (!isAllowedPush) {
            yield put({
                type: ActionTypes.DEVICE_INIT_FAILURE,
                payload: {
                    message: "Push notification disabled by settings"
                }
            });

            if (isDevelopment)
                message.info("Push notification dinonaktifkan");

            return;
        }

        if (!user) {
            yield put({
                type: ActionTypes.DEVICE_INIT_FAILURE,
                payload: { message: 'User not logged in' }
            });
            return;
        }

        console.log('[DEVICE_SAGA] Initializing device for user:', profile.id);

        // Initialize device
        const result = yield call([deviceService, deviceService.initializeDevice], profile.id);

        if (result?.success) {
            yield put({
                type: ActionTypes.DEVICE_INIT_SUCCESS,
                payload: {
                    deviceStatus: deviceService.getStatus(),
                    message: result?.message
                }
            });

            // Setup foreground listener
            yield call([firebaseService, firebaseService.setupForegroundListener]);

            if (isDevelopment)
                message.success('Device berhasil diinisialisasi');

        } else {
            yield put({
                type: ActionTypes.DEVICE_INIT_FAILURE,
                payload: {
                    error: result.error,
                    message: result.message
                }
            });

            if (isDevelopment)
                message.warning(`Device init gagal: ${result.message}`);
        }

    } catch (error) {
        console.error('[DEVICE_SAGA] Initialize device error:', error);

        yield put({
            type: ActionTypes.DEVICE_INIT_FAILURE,
            payload: {
                error: error.message,
                message: 'Failed to initialize device'
            }
        });
        if (isDevelopment)
            message.error('Gagal menginisialisasi device');
    }
}

// Action untuk logout device
export function* logoutDevice() {
    try {
        console.log('[DEVICE_SAGA] Logging out device...');


        const state = yield select();

        const appSetting = state?.app_setting?.response
        // console.log(state?.app_setting?.response)
        // console.log("Initial Device")

        if (!Boolean(appSetting?.user_config?.push_notifications)) {
            yield put({
                type: ActionTypes.DEVICE_INIT_FAILURE,
                payload: {
                    message: "Push notification disabled by settings"
                }
            });

            if (isDevelopment)
                message.info("Push notification dinonaktifkan");

            return;
        }

        const result = yield call([deviceService, deviceService.logoutFromDevice]);

        if (result?.success) {
            yield put({
                type: ActionTypes.DEVICE_LOGOUT_SUCCESS,
                payload: {
                    deviceStatus: deviceService.getStatus(),
                    message: result.message
                }
            });

            message.success('Berhasil logout dari device');

        } else {
            yield put({
                type: ActionTypes.DEVICE_LOGOUT_FAILURE,
                payload: {
                    error: result.error,
                    message: result.message
                }
            });

            message.warning(`Logout device gagal: ${result.message}`);
        }

    } catch (error) {
        console.error('[DEVICE_SAGA] Logout device error:', error);

        yield put({
            type: ActionTypes.DEVICE_LOGOUT_FAILURE,
            payload: {
                error: error.message,
                message: 'Failed to logout from device'
            }
        });

        message.error('Gagal logout dari device');
    }
}

// Action untuk get device status
export function* getDeviceStatus() {
    try {
        const status = yield call([deviceService, deviceService.getStatus]);

        yield put({
            type: ActionTypes.DEVICE_STATUS_SUCCESS,
            payload: { deviceStatus: status }
        });

    } catch (error) {
        console.error('[DEVICE_SAGA] Get device status error:', error);

        yield put({
            type: ActionTypes.DEVICE_STATUS_FAILURE,
            payload: {
                error: error.message,
                message: 'Failed to get device status'
            }
        });
    }
}

// Action untuk request notification permission
export function* requestNotificationPermission() {
    try {
        console.log('[DEVICE_SAGA] Requesting notification permission...');

        const permission = yield call([firebaseService, firebaseService.requestPermission]);

        yield put({
            type: ActionTypes.NOTIFICATION_PERMISSION_UPDATED,
            payload: { permission }
        });

        if (permission === 'granted') {
            // Initialize device jika permission granted
            yield call(initializeDevice);
            message.success('Izin notifikasi diberikan');
        } else if (permission === 'denied') {
            message.warning('Izin notifikasi ditolak');
        }

    } catch (error) {
        console.error('[DEVICE_SAGA] Request permission error:', error);

        yield put({
            type: ActionTypes.NOTIFICATION_PERMISSION_ERROR,
            payload: { error: error.message }
        });

        message.error('Gagal meminta izin notifikasi');
    }
}


// Helper delay function
const delay = (ms) => new Promise(resolve => setTimeout(resolve, ms));
// Watcher saga
export default function* deviceSaga() {
    yield takeLatest(ActionTypes.DEVICE_INIT_REQUEST, initializeDevice);
    yield takeLatest(ActionTypes.DEVICE_LOGOUT_REQUEST, logoutDevice);
    yield takeLatest(ActionTypes.DEVICE_STATUS_REQUEST, getDeviceStatus);
    yield takeLatest(ActionTypes.REQUEST_NOTIFICATION_PERMISSION, requestNotificationPermission);

    // Auto initialize device setelah login success
    yield takeEvery(ActionTypes.USER_LOGIN_SUCCESS, function* (action) {
        if (!action.payload.requires2FA) {
            // Delay sedikit untuk memberikan waktu redirect
            yield call(delay, 1000);
            yield call(initializeDevice);
        }
    });
}

